import { GetServerSideProps } from 'next'

import ThreadPage, { Props } from 'pages/forum/thread/[threadId]'

import { CommentService } from 'services/comment.service'

import { LOG_ERROR_AND_REDIRECT } from 'utils/ErrorString'
import { generateDeckUrl } from 'utils/deckSeo'

export default ThreadPage

// DEPRICATED ROUTE - /forum/thread/:threadId/:page - We no longer use this route (we use /forum/thread/:threadId instead). This is here to redirect old links to the new route
export const getServerSideProps: GetServerSideProps<Props> = async context => {
  try {
    const [threadId, page] = context.params?.threadOldRoute || []

    if (!threadId || !page) return { notFound: true }

    const thread = await new CommentService(context).details(threadId, page)

    if (!thread.parent && thread.deck)
      return { redirect: { destination: generateDeckUrl(thread.deck.id, thread.deck.name), permanent: false } }

    return { props: { thread, threadId, page } }
  } catch (err) {
    return LOG_ERROR_AND_REDIRECT(err, context)
  }
}
